import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getIncidentDetails,
  getReturnedIncidentDetails,
  insertIncident,
  updateIncident,
} from "../../redux/actionCreator";
import moment from "moment";
import { updateRedux } from "../../redux/commonReducer";
import { useDispatch } from "react-redux";
import { API_BASE_URL } from "../../constants/configuration";
import { fileUploadValidation } from "../../utils/validation";
import axios from "axios";

export default function UpdatesPage({ setStage }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const lang = localStorage.getItem("lang");

  const [details, setDetails] = useState({ files: [] });
  const [previousData, setPreviousData] = useState();
  const [thanksModal, setThanksModal] = useState(false);
  const [modalshow, setModalShow] = useState(false);
  const [fileView, setFileView] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [language, setLanguage] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");

  const [disableButtons, setDisabledButtons] = useState([]);

  const addToDisabled = (btn) => {
    setDisabledButtons([...disableButtons, btn]);
  };

  const removeFromDisabled = (btn) => {
    setDisabledButtons(disableButtons?.filter((e) => e != btn));
  };

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLanguage(lang);
  }, [localStorage.getItem("lang")]);

  const getBestServer = async () => {
    const det = await axios.get('https://api.ipify.org')
    setIpAddress(det?.data);
    // console.log(det?.data)
  }

  useEffect(() => {
    getBestServer()
  }, [])

  const fileViewHandler = (file) => {
    setFileView(file);
    setModalShow(true);
  };

  const handleClose = () => {
    setModalShow(false);
    setFileView(null);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props.label}
    </Tooltip>
  );

  useEffect(() => {
    params.id &&
      getReturnedIncidentDetails({ link_id: params.id }, (res) => {
        if (res.status) {
          if (res.incident_data) {
            setPreviousData(res.incident_data);
            dispatch(
              updateRedux({
                key: "update_report_no",
                value: res.incident_data.incident_no,
              })
            );
          }
        } else {
          if (res.time_expired) {
            setStage(7);
          } else {
            setStage(8);
          }
        }
      });
    // params.id && getIncidentDetails(params.id, (res) => {
    //     setPreviousData((res.incident_data))
    //     dispatch(updateRedux({ key: 'update_report_no', value: res.incident_data.incident_no }))
    // })
  }, [params]);

  async function submitHandler() {

    if (comment.trim().length === 0 && details?.files?.length === 0) {
      setCommentError(t("Reply or attachment is required"))
      return
    }
    if (comment && !(/^[a-zA-Z0-9ء-ي .؟،,-:!"?()'\n]+$/.test(comment))) {
      setCommentError(t("invalid_characters"))
      return
    }
    // if (!comment && details?.files?.length === 0) {
    //   setCommentError("invalid_characters")
    //   setFileUploadError("Attachments required");
    //   return
    // }
    let isValidated = await fileUploadValidation(details, setFileUploadError);
    if (isValidated) {
      addToDisabled("submitButton");
      setFileUploadError("");
      const formdata = new FormData();
      formdata.append("id", previousData?._id);
      details.files.forEach((item) => {
        formdata.append("incident_attachment", item);
      });
      if (window?.navigator?.appVersion.indexOf("Win") != -1) {
        formdata.append("os", "Windows");
      } else if (window?.navigator?.appVersion.indexOf("Mac") != -1) {
        formdata.append("os", "MacOS");
      } else if (window?.navigator?.appVersion.indexOf("X11") != -1) {
        formdata.append("os", "UNIX");
      } else if (window?.navigator?.userAgent.indexOf("Android") != -1) {
        formdata.append("os", "Android");
      } else if (window?.navigator?.appVersion.indexOf("Linux") != -1) {
        formdata.append("os", "Linux");
      }
      // if (window?.navigator?.userAgent.indexOf("Win") != -1) formData.append("os", "Windows");
      // if (window?.navigator?.userAgent.indexOf("Mac") != -1) formData.append("os", "Macintosh");
      // if (window?.navigator?.userAgent.indexOf("Linux") != -1) formData.append("os", "Linux");
      // if (window?.navigator?.userAgent.indexOf("Android") != -1) formData.append("os", "Android");
      // if (window?.navigator?.userAgent.indexOf("like Mac") != -1) formData.append("os", "iOS");
      // formdata.append("browser", window?.navigator?.appCodeName);
      if (
        (navigator.userAgent.indexOf("Opera") ||
          navigator.userAgent.indexOf("OPR")) != -1
      ) {
        formdata.append("browser", "Opera");
      }
      else if (navigator.userAgent.indexOf("Edg") != -1) {
        formdata.append("browser", "Edge");
      }
      else if (navigator.userAgent.indexOf("Chrome") != -1) {
        formdata.append("browser", "Chrome");
      }
      else if (navigator.userAgent.indexOf("Safari") != -1) {
        formdata.append("browser", "Safari");
      }
      else if (navigator.userAgent.indexOf("Firefox") != -1) {
        formdata.append("browser", "Firefox");
      }
      else if (
        navigator.userAgent.indexOf("MSIE") != -1 ||
        !!document.documentMode == true
      ) {
        //IF IE > 10
        formdata.append("browser", "IE");
      }
      formdata.append("ip", ipAddress);
      formdata.append("comment", comment);
      // setLoader(true)
      dispatch(
        updateIncident(formdata, () => {
          setThanksModal(true);
          removeFromDisabled("submitButton");
        })
      );
    }
  }

  return (
    <div className="UpdatesPage container">
      {previousData && (
        <>
          <Modal
            show={modalshow}
            centered
            onHide={handleClose}
            className="removeModfal preview-modal"
          >
            <Modal.Body>
              {fileView != null ? (
                <div>
                  {fileView?.type === "image/jpeg" ||
                    fileView?.type === "image/jpg" ||
                    fileView?.type === "image/webp" ||
                    fileView?.type === "image/png" ? (
                    <img
                      className="file"
                      src={URL.createObjectURL(fileView)}
                      alt=""
                    />
                  ) : fileView.type === "video/mp4" || fileView.type === "video/mov" || fileView.type === "video/quicktime" ? (
                    <video
                      src={URL.createObjectURL(fileView)}
                      width="320"
                      height="240"
                      controls
                    ></video>
                  ) : null}
                </div>
              ) : null}
              <p className="file-name">{fileView?.name}</p>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger" onClick={handleClose}>
                {t("close")}
              </button>
            </Modal.Footer>
          </Modal>
          <div className="report-details">
            <h2>{t("personal_information")}</h2>
            <section className="personal-info">
              <div className="row1">
                <div className="column">
                  <div>
                    <p className="title">{t("first_name")}</p>
                    <p className="value">{previousData?.first_name}</p>
                  </div>
                  <div>
                    <p className="title">{t("last_name")}</p>
                    <p className="value">{previousData?.last_name}</p>
                  </div>
                </div>
                <div className="column">
                  <div>
                    <p className="title">{t("email")}</p>
                    <p className="value">{previousData?.email}</p>
                  </div>
                  <div>
                    <p className="title">{t("phone_no")}</p>
                    <p className="value">+{previousData?.phone}</p>
                  </div>
                </div>
              </div>
            </section>
            <h2>{t("incident_report")}</h2>
            <section className="incident-repo">
              <div className="tab">
                <div className="row2">
                  <div className="column">
                    <div>
                      <p>{t("incident_type")}</p>
                      {previousData?.incident_type ? (
                        <p>
                          {language === "en"
                            ? previousData?.incident_type?.incident_type
                            : previousData?.incident_type?.incident_type_ar}
                        </p>
                      ) : null}
                    </div>
                    <div>
                      <p>{t("date_of_incident")}</p>
                      <p style={{ direction: "ltr" }} className="date">
                        {previousData?.incident_date ? moment(previousData?.incident_date).format(
                          "DD MMM YYYY"
                        ) : '--'}
                      </p>
                    </div>
                  </div>
                  <div className="column">
                    <div>
                      <p>{t("name_of_entity")}</p>
                      <p>{previousData?.incident_entity}</p>
                    </div>
                    <div>
                      <p>{t("is_this_incident_reported_elsewhere?")}</p>
                      <p>
                        {previousData?.is_reported_elsewhere === 1
                          ? t("yes")
                          : t("no")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row3">
                  <p>{t("description")}</p>
                  <p>{previousData?.incident_description}</p>
                </div>
              </div>
            </section>
          </div>
          <div className="reply updatepage-reply">
            <h2 style={{ display: 'flex' }}>{t("update_from_escd")} <span style={{ fontSize: 14, fontWeight: 'normal' }}>{moment(previousData?.returned_time).utc().format("DD MMMM YYYY | hh : mm A")}</span></h2>
            <p style={{ backgroundColor: '#f2e7e2', color: 'black', padding: 30 }}>{previousData?.return_reason}</p>
          </div>
          <div className="reply">
            <h2 style={{ display: 'flex' }}>{t("reply_to_message")}</h2>
          </div>
          <div className="attachment-files comment-section">
            <div className="input-group textarea">
              <textarea
                type="text"
                placeholder={t("write_your_message_here")}
                maxLength={2000}
                minLength={8}
                rows="5"
                value={comment}
                className={"return-comment"}
                onChange={(e) => {
                  setCommentError("")
                  setComment(e.target.value)
                }}
              />
              <div className="text-danger">
                <small>{t(commentError)}</small>
              </div>
            </div>
          </div>
          <div className="attachment-files">
            {details.files &&
              details.files.map((file, i) => {
                return (
                  <>
                    {file.type === "image/jpeg" ||
                      file.type === "image/webp" ||
                      file.type === "image/png" ||
                      file.type === "image/jpg" ? (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip({
                          label: file.name,
                        })}
                      >
                        <span className="file-container">
                          <img
                            className="file"
                            src={URL.createObjectURL(file)}
                            onClick={() => fileViewHandler(file)}
                            alt=""
                          />
                          <img
                            className="file-close"
                            onClick={() => (
                              setFileUploadError(""),
                              setDetails((s) => ({
                                ...s,
                                files: s.files.filter((item) => file != item),
                              }))
                            )}
                            src="./assets/img/icons/Group 11563.svg"
                            alt=""
                          />
                        </span>
                      </OverlayTrigger>
                    ) : file.type === "application/pdf" ? (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip({
                          label: file.name,
                        })}
                      >
                        <span className="file-container">
                          <a rel="noreferrer"
                            href={`${URL.createObjectURL(file)}`}
                            target="_blank"
                          >
                            <img
                              className="file"
                              src="./assets/img/icons/Group 11807.png"
                              alt=""
                            />
                            <img
                              className="file-close"
                              onClick={() => (
                                setFileUploadError(""),
                                setDetails((s) => ({
                                  ...s,
                                  files: s.files.filter((item) => file != item),
                                }))
                              )}
                              src="./assets/img/icons/Group 11563.svg"
                              alt=""
                            />
                          </a>
                        </span>
                      </OverlayTrigger>
                    ) : file.type === "video/mp4" || file.type === "video/mov" || file.type === "video/quicktime" ? (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip({
                          label: file.name,
                        })}
                      >
                        <span className="file-container">
                          <img
                            className="file"
                            src="./assets/img/icons/v1.png"
                            alt=""
                            onClick={() => fileViewHandler(file)}
                          />
                          <img
                            className="file-close"
                            src="./assets/img/icons/Group 11563.svg"
                            alt=""
                            onClick={() => (
                              setFileUploadError(""),
                              setDetails((s) => ({
                                ...s,
                                files: s.files.filter((item) => file != item),
                              }))
                            )}
                          />
                        </span>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip({
                          label: file.name,
                        })}
                      >
                        <span className="file-container error-file">
                          <img
                            className="file"
                            src="./assets/img/icons/error file.svg"
                            alt=""
                            onClick={() => fileViewHandler(file)}
                          />
                          <img
                            className="file-close"
                            src="./assets/img/icons/Group 11563.svg"
                            alt=""
                            onClick={() => {
                              setDetails((s) => ({
                                ...s,
                                files: s.files.filter((item) => file != item),
                              }));
                              setFileUploadError("");
                            }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                  </>
                );
              })}
          </div>
          <div className="buttons-carrier d-flex jusit">
            <div className="buttons d-flex flex-column padding-0">
              <div className="d-flex gap-3 flex-column flex-lg-row">
                <label className="attachment" htmlFor="upload-attachment">
                  <img
                    src="./assets/img/icons/Icon awesome-upload.svg"
                    alt=""
                  />
                  <input
                    type="file"
                    name=""
                    id="upload-attachment"
                    multiple
                    hidden
                    accept=".jpg, .png, .pdf, .jpeg, .PDF, .mp4 , .mov"
                    onClick={(e) => (e.target.value = null)}
                    onChange={(e) => {
                      setDetails((s) => ({
                        ...s,
                        files: [...s.files, ...Array.from(e.target.files)],
                      }));
                      setFileUploadError("");
                    }}
                  />
                  {t("add_attachments")}
                </label>
                {/* <span className="supported__formats">
                            <p>{t('attachment_file_types')} </p>
                            <p> {t('attachment_file_size')} </p>
                        </span> */}
              </div>
              <div className="text-danger">
                <small>{t(fileUploadError)}</small>
              </div>
            </div>
            <div className="submit-button updates-page margin-0 d-flex flex-column" style={{}}>
              <button
                className="next-button mt-5 mt-lg-1"
                style={{ "max-width": "170px" }}
                onClick={() => submitHandler()}
                disabled={disableButtons?.includes("submitButton")}
              >
                {disableButtons?.includes("submitButton") && (<img className="load" src="./assets/img/icons/loader.svg" alt="" />)}
                {t("submit")}
                <img
                  className="right"
                  src="./assets/img/icons/Icon awesome-arrow-right.svg"
                  alt=""
                />
              </button>
            </div>
          </div>
          <Modal show={thanksModal} className="thank-you-modal">
            <Modal.Body>
              <img
                className="tick"
                src="./assets/img/icons/Icon awesome-check-circle.svg"
                alt=""
              />
              <h2>{t("thank_you")}</h2>
              <Link className="next-button" to={"/"} rel="noreferrer">
                <img
                  className="arrow left"
                  src="./assets/img/icons/Icon awesome-arrow-right.svg"
                  alt=""
                />
                {t("back_to_home_page")}
              </Link>
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  );
}

export const SmsLanding = () => {
  const params = useParams();
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") ?? "ar";
  console.log(lang, "lang")

  useEffect(() => {
    params.id && navigate(`/${lang}/incident_update/` + params.id);
  }, [params]);

  return null;
};
